import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import {connect} from "react-redux";
import {actions} from "../../actions";
import _ from 'lodash';

import ArtifactRow from './ArtifactRow';

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto',
    },
    table: {
        minWidth: 700,
    },
});

class ArtifactReviewTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 0,
            rowsPerPage: 10,
            artifacts: [],
            numArtifacts: 0
        };
    };


    renderRows() {
        let reviewer = this.props.reviewers.find(x => x.unid === this.props.user.unid);

        if (reviewer.artifactScores && reviewer.artifactScores.length > 0) {
            return _.map(reviewer.artifactScores, row => {
                let artifact = this.props.artifacts.find(x => x.canvas_submission_id === row.artifact_id);
                let course = this.props.form.courses.find(x => x.canvas_course_id === artifact.canvas_course_id);
                artifact.course_code = course.course_code;
                artifact.name = course.name;
                return (
                    <ArtifactRow key={artifact.canvas_submission_id + '-' + artifact.canvas_user_id} row={artifact}/>
                );
            })
        }
    }

    render() {
        const {classes} = this.props;
        return (
            <Paper className={classes.root}>
                <Table className={classes.table}>
                    <TableHead>
                        <TableRow>
                            <TableCell>Assignment</TableCell>
                            <TableCell>Type</TableCell>
                            <TableCell>Course</TableCell>
                            <TableCell>Score</TableCell>
                            <TableCell>Artifact ID</TableCell>
                            <TableCell>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {this.renderRows()}
                    </TableBody>
                </Table>
            </Paper>
        );
    }
}

function mapStateToProps(state) {
    return {
        form: state.newAssessmentForm,
        artifacts: state.artifacts,
        reviewers: state.reviewers,
        user: state.user
    };
}

export default connect(mapStateToProps, actions)(withStyles(styles)(ArtifactReviewTable));
